
import styled from 'styled-components'

const FieldWrapper = styled.div`
margin-bottom: 20px;
`

export default FieldWrapper
